import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TNotificationItem, TNotificationState } from './notifications.types';

const initialState: TNotificationState = {
  notification: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    pushNotification: (state, action: PayloadAction<TNotificationItem>) => {
      state.notification = action.payload;
    },
  },
});

export const { pushNotification } = notificationsSlice.actions;

export const notificationsReducer = notificationsSlice.reducer;
